import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuardGuard  {
  /**
   *
   */
  constructor(private data: DataService) {
    
  }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): boolean {
      if (this.data.isLoggedIn == true && this.data.SelectedProperty != null){
        return true;
      }else {
        return false;
      }

    
  }
  
}
